import { forwardRef, type SelectHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: Array<{ value: string; label: string }>;
  children?: ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, children, className, style, ...props }, ref) => (
    <select
      ref={ref}
      style={{
        height: 36,
        padding: '0 12px',
        borderRadius: 6,
        border: '1px solid #cbd5e1',
        background: '#fff',
        fontSize: 14,
        width: '100%',
        ...style,
      }}
      className={cn('select', className)}
      {...props}
    >
      {options
        ? options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))
        : children}
    </select>
  ),
);
Select.displayName = 'Select';